<template>
  <section
    class="component-bbf0c1bb"
    resmed-component-name="feature_fullwidth_h54_text_2cta"
    v-bind:data-step="acf.steps.next ? acf.steps.next - 1 : acf.steps.total"
  >
    <div
      class="component -transition-in-view"
      v-bind:class="{
        [`placement-${acf.layout['content-placement']}`]: true,
        [`text-color-${acf.layout['text-color']}`]: true,
        [`component-height-${acf.layout['component-height']}`]: true,
      }"
    >
      <div
        class="embed-responsive"
        v-bind:class="{
          'embed-responsive-21by9': $root.mode === 'lg' || $root.mode === 'xl',
          'embed-responsive-16by9': $root.mode === 'md',
          'embed-responsive-33by40': $root.mode === 'xs' || $root.mode === 'sm',
        }"
        v-bind:style="{
          background: acf.layout['background-color']
            ? acf.layout['background-color']
            : '#232323',
          'background-size': 'cover',
          'background-position': 'center top',
          'background-repeat': 'no-repeat',
        }"
      >
        <template v-if="!acf.steps.step">
          <!-- background image -->
          <div
            v-if="acf.layout.background === 'image'"
            class="hero-bg embed-responsive-item"
            v-bind:style="style"
          ></div>

          <!-- background video -->
          <background-video
            v-if="acf.layout.background === 'video'"
            v-bind:file="video"
            v-bind:img="acf.layout.video_replacement"
            v-bind:opacity="acf.layout.opacity"
            :key="componentKey"
          >
          </background-video>
        </template>

        <!-- steps -->
        <template v-if="acf.steps.step">
          <img
            v-if="
              ($root.mode === 'xs' || $root.mode === 'sm') &&
              acf.layout['background-image-xs']
            "
            style="width: 100%"
            v-bind:src="acf.layout['background-image-xs']"
            alt=""
          />
          <div
            v-else
            class="hero-bg embed-responsive-item"
            v-bind:style="style"
          ></div>
        </template>

        <div class="wrapper px-xs-sm-2">
          <div class="container">
            <div class="row">
              <div
                class="col -in-view-slide-fade-lr"
                v-bind:class="{
                  'col-md-10 offset-lg-1': acf.layout['span-10'],
                  'col-md-7 offset-lg-1':
                    acf.layout['content-placement'] === 'left' &&
                    !acf.layout['offset'],
                  'col-md-6 offset-lg-0':
                    acf.layout['content-placement'] === 'left' &&
                    acf.layout['offset'],
                  'col-md-8 offset-md-2':
                    acf.layout['content-placement'] === 'center',
                  'col-md-7 offset-md-5':
                    acf.layout['content-placement'] === 'right',
                }"
              >
                <div v-bind:style="transform">
                  <h5 v-if="acf.steps.step" class="step">
                    {{ acf.steps.step }}
                  </h5>
                  <eyebrow-icon
                    v-if="acf.eyebrowicon"
                    v-bind:eyebrowicon="acf.eyebrowicon"
                    v-bind:align="
                      acf.layout['content-placement'] === 'center'
                        ? 'center'
                        : ''
                    "
                  ></eyebrow-icon>
                  <h1
                    v-if="
                      acf.layout['heading-tag'] === 'h1' ||
                      !acf.layout['heading-tag']
                    "
                    v-html="acf.headline"
                    v-bind:class="{ '-has-eyebrow': acf.eyebrow }"
                  ></h1>
                  <h2
                    v-if="acf.layout['heading-tag'] === 'h2'"
                    v-html="acf.headline"
                    v-bind:class="{ '-has-eyebrow': acf.eyebrow }"
                  ></h2>

                  <div
                    v-if="acf.introduction"
                    v-html="acf.introduction"
                    class="introduction pt-3 pb-4"
                  ></div>
                  <pro-tip
                    v-if="acf['healthcare-pro-tip'].excerpt"
                    v-bind:acf="acf['healthcare-pro-tip']"
                  ></pro-tip>

                  <!-- app store -->
                  <div
                    class="resources mb-3"
                    v-if="acf['apple-app-store'] || acf['google-play']"
                  >
                    <a
                      v-if="acf['apple-app-store']"
                      target="_blank"
                      v-bind:href="acf['apple-app-store']"
                      class="btn apple-store d-block text-hide mr-3"
                      >Download on the App Store</a
                    >
                    <a
                      v-if="acf['google-play']"
                      target="_blank"
                      v-bind:href="acf['google-play']"
                      class="btn google-play d-block text-hide"
                      >Get it on Google Play</a
                    >
                  </div>

                  <!-- call to action -->
                  <div
                    v-if="acf.cta.length || acf.steps.next"
                    class="cta-steps"
                  >
                    <template v-if="acf.cta.length >= 1">
                      <!-- first cta, with modal option -->
                      <a
                        v-if="acf.modal.player"
                        href="#"
                        class="
                          btn
                          cta-pill
                          filled-red
                          icon
                          right-arrow
                          mb-2
                          mr-2
                        "
                        v-bind:modal-video-id="acf.modal.id"
                        v-on:click.prevent="modal(acf.modal.player, acf.modal.id, acf.modal.aprimo_url, acf.modal.aprimo_subtitle)"
                        >{{ acf.cta[0].cta.text }}</a
                      >
                      <a
                        v-else
                        v-bind:href="acf.cta[0].cta.href"
                        v-bind:target="acf.cta[0].cta.target"
                        class="
                          btn
                          cta-pill
                          filled-red
                          icon
                          right-arrow
                          mb-2
                          mr-2
                        "
                        >{{ acf.cta[0].cta.text }}</a
                      >
                    </template>

                    <!-- second cta: optional. no modal -->
                    <a
                      v-if="acf.cta.length === 2"
                      v-bind:href="acf.cta[1].cta.href"
                      v-bind:target="acf.cta[1].cta.target"
                      class="
                        btn
                        cta-pill
                        hallow-white
                        icon
                        right-arrow
                        mb-2
                        mr-2
                      "
                      >{{ acf.cta[1].cta.text }}</a
                    >

                    <!-- next step -->
                    <a
                      v-if="acf.steps.next"
                      v-bind:href="'#'"
                      v-on:click.prevent="next(acf.steps.next)"
                      class="btn cta-pill icon right-arrow"
                      v-bind:class="{
                        'hallow-red': acf.layout['text-color'] === 'black',
                        'hallow-white': acf.layout['text-color'] === 'white',
                      }"
                      >Next step</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <steps-fcbecf18
          v-if="acf.steps.step"
          v-bind:acf="acf.steps"
          v-bind:translate="'1'"
        ></steps-fcbecf18>
      </div>
    </div>
  </section>
</template>

<script>
import debounce from "lodash/debounce";
import backgroundVideo from "../shared-support/background-video";
import stepsFcbecf18 from "../shared-support/steps-fcbecf18";
import proTip from "../shared-support/healthcare-pro-tip";
import { scroll } from "../../mixins/index";

export default {
  name: "component-bbf0c1bb", // feature_fullwidth_h54_text_2cta
  props: ["acf"],
  mixins: [scroll],
  components: {
    backgroundVideo,
    stepsFcbecf18,
    proTip,
  },
  data() {
    return {
      video: "", // video file
      componentKey: 0,
      style: {},
      transform: {
        transform: "",
      },
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        if (val === "xs" || val === "sm") {
          this.style["background-image"] = this.acf.layout[
            "background-image-xs"
          ]
            ? `url(${this.acf.layout["background-image-xs"]})`
            : `url(${this.acf.layout["background-image"]})`;

          this.transform["transform"] = this.acf.layout["transform-xs"];
        } else {
          this.style[
            "background-image"
          ] = `url(${this.acf.layout["background-image"]})`;
          this.transform["transform"] = "";
        }

        if (this.acf.layout["background-position"]) {
          this.style["background-position"] =
            this.acf.layout["background-position"];
        }
      },
      immediate: true,
    },
  },
  methods: {
    next(arg) {
      this.$nextTick(() => {
        this.scroll({
          to: `[data-step='${arg}']`,
          offset: ["xs", "sm", "md"].includes(this.$root.mode) && 90,
        });
      });
    },
    modal(...arg) {
      bus.$emit("overlay:active", {
        active: true,
        player: arg[0],
        id: arg[1],
        aprimo_url: arg[2] || null,
        aprimo_subtitle: arg[3] || null
      });
    },
    forceRerender() {
      this.componentKey += 1;
    },
    debounce(arr) {
      // initial load
      if (!arr[1]) {
        if (arr[0] === "lg" || arr[0] === "xl") {
          this.video = this.acf.layout.video_21by9;
        }
        if (arr[0] === "md") {
          this.video = this.acf.layout.video_16by9;
        }
        if (arr[0] === "xs" || arr[0] === "sm") {
          this.video = this.acf.layout.video_33by40;
        }
        this.forceRerender();

        return;
      }

      // from --> lg xl
      // to   --> md
      if ((arr[1] === "lg" || arr[1] === "xl") && arr[0] === "md") {
        this.video = this.acf.layout.video_16by9;
        this.forceRerender();

        return;
      }

      // from --> md
      // to   --> lg xl
      if ((arr[0] === "lg" || arr[0] === "xl") && arr[1] === "md") {
        this.video = this.acf.layout.video_21by9;
        this.forceRerender();

        return;
      }

      // from --> md
      // to   --> xs sm
      if (arr[1] === "md" && (arr[0] === "xs" || arr[0] === "sm")) {
        this.video = this.acf.layout.video_33by40;
        this.forceRerender();

        return;
      }

      // from --> xs sm
      // to   --> md
      if (arr[0] === "md" && (arr[1] === "xs" || arr[1] === "sm")) {
        this.video = this.acf.layout.video_16by9;
        this.forceRerender();

        return;
      }
    },
  },
  created() {
    let _debounce = debounce((arr) => {
      this.debounce(arr);
    }, 50);

    bus.$on("mode", (arr) => {
      _debounce(arr);
    });

    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component {
  &.component-height-fixed {
    // --> default:; based on embed-responsive ratio(s)
  }

  &.component-height-flex {
    .embed-responsive {
      &:before {
        display: none;
      }
    }

    .wrapper {
      position: relative;
      transform: none;
      padding: 3rem 0;

      @media (min-width: 992px) {
        min-height: 520px;
        padding: 6rem 0 4rem 0;
      }
    }
  }

  &.placement-center {
    text-align: center;

    h1,
    h2 {
      &.-has-eyebrow {
        position: relative;
        @extend %eyebrow-center;
      }
    }

    .resources {
      justify-content: center;
    }
  }

  &.placement-left,
  &.placement-right {
    h1,
    h2 {
      &.-has-eyebrow {
        position: relative;
        @extend %eyebrow-left;
      }
    }
  }

  &.text-color-black {
    h1,
    h2 {
      color: $cc-resmed-black;

      &.-has-eyebrow {
        &:before {
          background-color: $cc-resmed-black;
        }
      }
    }

    .introduction * {
      color: $cc-resmed-black;
    }
  }

  &.text-color-white {
    h1,
    h2 {
      color: rgba($cc-resmed-white, 0.875);

      &.-has-eyebrow {
        &:before {
          background-color: $cc-resmed-white;
        }
      }
    }

    .introduction * {
      color: $cc-resmed-white;
    }
  }

  h1,
  h2 {
    margin: 0 0 0.325rem 0;
  }

  h5 {
    &.step {
      margin: 0 0 2.25rem 0;

      &:before {
        top: 2.25rem;
      }
    }

    ~ h2 {
      &:before {
        top: -1.325rem !important;
      }
    }
  }

  .embed-responsive {
    .hero-bg {
      background-size: cover;
      background-position: center top;
      background-repeat: no-repeat;
      opacity: 0.7;

      @media (min-width: 992px) {
        opacity: 1;
      }
    }
  }

  .wrapper {
    min-width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .cta-steps {
    a {
      &:last-child {
        margin-bottom: 0 !important;
        margin-right: 0 !important;
      }
    }
  }

  .resources {
    display: flex;

    .btn {
      @media (min-width: 768px) {
        margin-right: 1.5rem;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  // citation - exception
  .embed-responsive {
    overflow: visible;
  }
}
</style>